import { upstreamApi } from '../upstreamApi';
import { accessToken } from '../utils/Tokens';
import { DELETE_ME, LOGIN, LOGOUT, SEND_LOGIN_EMAIL } from './actionTypes';
import { asyncAction } from './asyncAction';
import { addFlashMessage, toast } from './toastActions';
import { UPSTREAM_EMAIL_ADDRESS } from 'upstream-shared/constants';
import { paths } from '../paths';

export const sendLoginEmail = (payload: { email: string; redirectTo?: string }) => {
  return asyncAction({
    actionType: SEND_LOGIN_EMAIL,
    requestPayload: payload,
    func: async () => {
      accessToken.delete();
      return (await upstreamApi.auth.sendLoginEmail(payload)).data;
    },
    onSucceeded: async (result, dispatch) => {
      return dispatch(
        toast.showSucceeded({
          message:
            'Check your email for a message you can use to log in. ' +
            `Or email ${UPSTREAM_EMAIL_ADDRESS} if you are having difficulties.`,
        }),
      );
    },
    onFailed: async (result, dispatch) =>
      dispatch(
        toast.showFailed({
          message:
            'We were not able to send a login email. If you are a subscriber and believe this is an error, please ' +
            ` email ${UPSTREAM_EMAIL_ADDRESS} for help.`,
        }),
      ),
  });
};

export const login = (token: string, showFailure = true) => {
  return asyncAction({
    actionType: LOGIN,
    func: async () => {
      accessToken.delete();
      return (await upstreamApi.auth.login(token)).data;
    },
    onFailed: async (result, dispatch, getState) => {
      if (showFailure) {
        const authUser = getState().auth.authUser;
        dispatch(
          toast.showFailed({
            title: 'Login failed.',
            message:
              'Login links expire after 10 minutes, can only be used once, and ' +
              'only the most recent one will work. ' +
              (authUser ? 'You are already logged in as ' + authUser.email + '. ' : 'Please request a new login link. ') +
              `Email ${UPSTREAM_EMAIL_ADDRESS} if you are having difficulties.`,
          }),
        );
      }
    },
  });
};

export const logout = () => {
  return asyncAction({
    actionType: LOGOUT,
    func: async () => {
      try {
        await upstreamApi.auth.logout();
      } finally {
        accessToken.delete();
      }
    },
  });
};

export const deleteMe = () => {
  return asyncAction({
    actionType: DELETE_ME,
    func: async () => {
      return (await upstreamApi.auth.deleteMe()).data;
    },
    onSucceeded: async (_result, dispatch) => {
      accessToken.delete();
      dispatch(addFlashMessage({ kind: 'success', message: 'Your account has been deleted.' }));
      window.location.href = paths.LOGIN;
    },
    onFailed: async (_result, dispatch) => {
      dispatch(
        toast.showFailed({
          title: 'Delete failed.',
          message: `We couldn't delete your account. Please try again or email ${UPSTREAM_EMAIL_ADDRESS}.`,
        }),
      );
    },
  });
};
